const guide = [{
		title: '公积金提取',
		child: [{
			title: '租房提取',
			child: [{
				title: '北京市行政区域内租住公租房',
				doc: '公租房.docx'
			}, {
				title: '不提供租住商品住房合同和发票',
				doc: '租房1500.docx'
			}, {
				title: '提供北京市行政区域内租住商品住房合同和发票',
				doc: '租房(发票).docx'
			}]
		}, {
			title: '北京购房提取',
			child: [{
				title: '购买北京行政区域内商品房',
				doc: '商品房.docx'
			}, {
				title: '购买北京行政区域内公有住房、集资建房',
				doc: '公有住房.docx'
			}, {
				title: '使用北京住房公积金管理中心贷款购买住房',
				doc: '北京-公积金贷款.docx'
			}, {
				title: '购买北京行政区域内经济适用房、限价商品房',
				doc: '经济适用房.docx'
			}, {
				title: '购买北京行政区域内危改、拆迁、征收回迁房',
				doc: '危改、拆迁、征收回迁房.docx'
			}]
		}, {
			title: '异地购房提取',
			child: [{
				title: '购买北京市行政区域外住房',
				doc: '外地全款.docx'
			}, {
				title: '使用商业银行贷款及使用异地公积金贷款购买北京市行政区域外住房',
				doc: '外地贷款.docx'
			}]
		}, {
			title: '同一住房非首次提取',
			doc: '非首次.docx'
		}, {
			title: '婚姻关系提取',
			doc: '婚姻关系提取.docx'
		}, {
			title: '大修、翻建、自建住房提取',
			doc: '大修.docx'
		}]
	},
	{
		title: '销户提取',
		child: [{
			title: '退休销户提取',
			doc: '退休.docx'
		}, {
			title: '继承人、受遗赠人销户提取',
			doc: '继承.docx'
		}, {
			title: '出境定居户口注销销户提取',
			doc: '出境.docx'
		}, {
			title: '非本市户籍人员与单位解除劳动关系销户提取',
			doc: '销户.docx'
		}]
	},
	{
		title: '公积金转入',
		doc: '转入.docx'
	},
	{
		title: '公积金转出',
		doc: '转出.docx'
	},
	{
		title: '公积金查询',
		doc: '查询.docx'
	},
	{
		title: '公积金用卡',
		doc: '公积金用卡.docx'
	},
	{
		title: '表格下载',
		child: [{
			title: '申请提取住房公积金个人授权、承诺书',
			doc: '个人授权承诺书.pdf',
			view: false
		}, {
			title: '住房公积金表114 北京住房公积金缴存人账户转移申请表（20190515版）',
			doc: '114.pdf',
			view: false
		}]
	},
	{
		title: '公积金业务网点',
		doc: '公积金业务网点.xlsx'
	}
]

export default guide
